<nz-page-header nzTitle="Member List"></nz-page-header>

<a [routerLink]="['/category/new']" nz-button nzType="dashed" class="mb-1" >+ Add New Category</a>
<nz-table nzSize="small" [nzData]="[1]" [nzFrontPagination]="false">
	<thead>
		<tr>
			<th>Action</th>
			<th>Name</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of data" (dblclick)="doView(item)">
			<td>
				<a [routerLink]="['/category',item.id,'edit']" class="btn btn-sm btn-secondary">Open</a>
			</td>
			<td>{{item.name}}</td>
		</tr>
	</tbody>
</nz-table>
